<ng-container *transloco="let t; read: 'configuration-sentiment-component'">
  <app-configuration-item-editor
    [configuration]="configuration()"
    [configurationLayers]="configurationLayers()"
    [itemTypeTitle]="itemType"
    searchPlaceholder="{{ t('search-placeholder') }}"
    queryPlaceholder="{{ t('query-placeholder') }}"
    queryPropName="name"
    syntaxHelpLink="https://semantria-docs.lexalytics.com/docs/sentiment-bearing-phrases"
    [loadItemsApi]="loadItems"
    [createItemApi]="createItem"
    [saveItemApi]="saveItem"
    [deleteItemApi]="deleteItem"
    [deleteAllItemsApi]="deleteAllItems"
    [evaluateItemApi]="evaluateItem"
    [getEvaluationConfigApi]="getEvaluationConfig"
    [getHighlightTextString]="getHighlightText"
    [getEvaluationItemHighlightValue]="getItemHighlightValue"
    [getEvaluationItemByClonedFrom]="getItemByClonedFrom"
    [deleteEvaluationConfigApi]="deleteEvaluationConfig"
    [nameEditable]="false"
    [itemsEditable]="editable()"
    [testingEnabled]="canTestItem()"
    [selectedItemName]="selectedItemName"
    [selectedItemId]="selectedItemId"
    [editorTemplate]="editorData"
    [rowExtraTemplate]="rowData"
    fragment="sentiment"
    (selectedItemChange)="onItemEditing($event)"
    (saving)="onItemSaving($event)"
    (itemsDeleted)="onItemsDeleted($event)"
    (allItemsDeleted)="onAllItemsDeleted($event)"
    (itemAdded)="onItemAdded($event)"
    (itemUpdated)="onItemUpdated($event)"
  ></app-configuration-item-editor>

  <ng-template #rowData let-item>
    <app-sentiment-display
      [showTooltip]="false"
      sentimentDisplay="numeric"
      [sentimentRanges]="weightRanges"
      [sentimentScale]="3"
      [sentiment]="item"
    >
    </app-sentiment-display>
  </ng-template>

  <ng-template #editorData let-item>
    <div class="configuration-sentiment__weight-editor-wrapper">
      <div class="configuration-sentiment__weight-editor-slider">
        <span>{{ t('sentiment-weight') }}</span>

        <xi-slider
          color="CX"
          [disabled]="isSaving || !canEditItem()"
          [min]="sliderLimits.min"
          [max]="sliderLimits.max"
          [increment]="1e-1"
          [inflection]="{
            inflectionPoint: 0,
            sentimentLeft: 'negative',
            sentimentRight: 'positive',
          }"
          [(value)]="item.weight"
          (onSliderChange)="onWeightChanged($event.detail.value)"
        ></xi-slider>
      </div>

      @if (item.weight === 0) {
        <div class="configuration-sentiment__weight-editor-warning">
          {{ t('0-warning') }}
        </div>
      }
    </div>
  </ng-template>
</ng-container>
